import { useEffect, useRef } from 'react';

/**
 * Hook that runs an effect only once when a component mounts.
 * This is useful for initialization logic that should only run once.
 *
 * @param effect - The effect to run on mount
 */
const useOnMount = (effect: () => void) => {
  const hasRun = useRef(false);

  useEffect(() => {
    // In strict mode, the effect will run twice, so we need to prevent it from running twice
    if (!hasRun.current) {
      hasRun.current = true;
      effect();
    }
  }, [effect]); // Include effect in dependencies since we're using it in the callback
};

export default useOnMount;
